export class CsvUtils {

  static parseCSV(csvData: string): any[] {
    const lines: string[] = csvData.split(/\r?\n|\r/);
    const headers: string[] = lines[0].split(',');
    const headersLowerCase: string[] =  headers.map((columnLine) => columnLine.toLowerCase());
    const data: any[] = [];

    lines.slice(1).forEach(line => {
      const row: string[] = line.split(',');
      if (row.length === headersLowerCase.length) {
        const rowData: Record<string, string> = {};
        headersLowerCase.forEach((header, index) => {
          rowData[header] = row[index];
        });
        data.push(rowData);
      }
    });
    return data;
  }
}
